import {
    UPDATECHARGEBACK_SUCCESS,
    UPDATECHARGEBACK_FAILED,
    RESET_UPDATECHARGEBACK,
    LOADING_UPDATECHARGEBACK,
    NETWORK_ERROR_UPDATECHARGEBACK,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateChargeback = () => {
    return { type: RESET_UPDATECHARGEBACK };
};

/**
 * Submit multiple chargebacks in a single call.
 *
 * Request shape:
 * {
 *   chargebacks: [
 *     { transactionId: "TXN1001", amount: 100.50, reason: "Fraudulent transaction" },
 *     { transactionId: "TXN1002", amount: 250.00, reason: "Duplicate transaction"  },
 *     { transactionId: "TXN1003", amount: 75.25,  reason: "Customer dispute"       },
 *   ]
 * }
 */
const updateChargeback =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_UPDATECHARGEBACK });
        await partnerServices
            .post("chargeback", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(updateChargebackSuccess(res.data));
                        break;
                    default:
                        dispatch(updateChargebackFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_UPDATECHARGEBACK,
                    payload: err,
                });
            });
    };

function updateChargebackSuccess(data) {
    return {
        type: UPDATECHARGEBACK_SUCCESS,
        payload: data,
    };
}

function updateChargebackFailed(data) {
    return {
        type: UPDATECHARGEBACK_FAILED,
        payload: data,
    };
}

export { resetUpdateChargeback, updateChargeback };